"use client";
import React from "react";
import { Container, Row, Col, Button, Accordion } from "react-bootstrap";
import { motion } from "framer-motion";
import { useState, useEffect } from "react";

export default function EcloudComp(index){
    const [isMobile, setIsMobile] = useState(false);
    
      useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 1100);
        handleResize(); // Set initial state
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
      }, []);
    
      const boxVariantsL = !isMobile
        ? {
            hidden: { opacity: 0, x: index % 2 === 0 ? 350 : -350 },
            visible: { opacity: 1, x: 0, transition: { duration: 0.7 } },
          }
        : { hidden: { opacity: 1 }, visible: { opacity: 1 } };
    
      const boxVariantsR = !isMobile
        ? {
            hidden: { opacity: 0, x: index % 2 === 0 ? -350 : 350 },
            visible: { opacity: 1, x: 0, transition: { duration: 0.7 } },
          }
        : { hidden: { opacity: 1 }, visible: { opacity: 1 } };
    
      const boxVariantsPop = !isMobile
        ? {
            hidden: { opacity: 0, scale: 0.2 },
            visible: { opacity: 1, scale: 1, transition: { duration: 1 } },
          }
        : { hidden: { opacity: 1 }, visible: { opacity: 1 } };
    
      const boxVariantsY = !isMobile
        ? {
            hidden: { opacity: 0, y: index % 2 === 0 ? -350 : 350 },
            visible: { opacity: 1, y: 0, transition: { duration: 0.7 } },
          }
        : { hidden: { opacity: 1 }, visible: { opacity: 1 } };
    
    return(<>
      <Row className="m-l-0 m-r-0 p-l-0 p-r-0">
        <Container fluid className="p-l-0 p-r-0 ">
          <Container>
            <Row className="mt-1 text-start">
              <Col xs={12} md={6} className="motion-container sticky-top">
                {!isMobile ? (
                  <motion.div
                    variants={boxVariantsL}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0 }}
                  >
                    <img
                      src="/Images/LC/digiFiling.gif"
                      alt="Products"
                      className="img-fluid"
                    />
                  </motion.div>
                ) : (
                  <div>
                    <img
                      src="/Images/LC/digiFiling.gif"
                      alt="Products"
                      className="img-fluid"
                    />
                  </div>
                )}
              </Col>
              <Col xs={12} md={6} className="motion-container">
                {!isMobile ? (
                  <motion.div
                    variants={boxVariantsR}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0 }}
                  >
                    <h3 className="font-bold" style={{ color: "rgb(6 23 68)" }}>
                      Key Benefits of E-Cloud:
                    </h3>

                    <ul className="list-items list-items-layout2 list-unstyled text-left">
                      <li>
                        Organized Filing: Keep all forms and documents
                        systematically organized based on timeframes (monthly,
                        quarterly, half-yearly, yearly).
                      </li>
                      <li>
                        Real-Time Updates: Vessels can update the repository in
                        real-time, ensuring that the most current information is
                        always available.
                      </li>
                      <li>
                        Reduced Email Communication: Minimize email traffic and
                        streamline communication by maintaining a centralized
                        document repository.
                      </li>
                      <li>
                        Anytime, Anywhere Access: Access critical documents from
                        any location, ensuring you are always in touch with
                        essential data.
                      </li>
                      <li>
                        Enhanced Traceability: Maintain a clear and retrievable
                        record of all ship's reports, ensuring that documents
                        are never misplaced or lost.
                      </li>
                      <li>
                        Robust Security: End-to-end encryption keeps your data
                        safe and secure from unauthorized access.
                      </li>
                      <li>
                        Email Reduction: By utilizing a centralized filing
                        system, save the effort and time involved in sending
                        millions of emails every year.
                      </li>
                    </ul>
                  </motion.div>
                ) : (
                  <div>
                    <h3 className="font-bold" style={{ color: "rgb(6 23 68)" }}>
                      Key Benefits of E-Cloud:
                    </h3>

                    <ul className="list-items list-items-layout2 list-unstyled text-left">
                      <li>
                        Organized Filing: Keep all forms and documents
                        systematically organized based on timeframes (monthly,
                        quarterly, half-yearly, yearly).
                      </li>
                      <li>
                        Real-Time Updates: Vessels can update the repository in
                        real-time, ensuring that the most current information is
                        always available.
                      </li>
                      <li>
                        Reduced Email Communication: Minimize email traffic and
                        streamline communication by maintaining a centralized
                        document repository.
                      </li>
                      <li>
                        Anytime, Anywhere Access: Access critical documents from
                        any location, ensuring you are always in touch with
                        essential data.
                      </li>
                      <li>
                        Enhanced Traceability: Maintain a clear and retrievable
                        record of all ship's reports, ensuring that documents
                        are never misplaced or lost.
                      </li>
                      <li>
                        Robust Security: End-to-end encryption keeps your data
                        safe and secure from unauthorized access.
                      </li>
                      <li>
                        Email Reduction: By utilizing a centralized filing
                        system, save the effort and time involved in sending
                        millions of emails every year.
                      </li>
                    </ul>
                  </div>
                )}
              </Col>
            </Row>
          </Container>
        </Container>
      </Row>

      <Row className="m-l-0 m-r-0 p-l-0 p-r-0 pt-5">
        <Container>
          <Row>
            <Col xs={12} className="motion-container">
            {!isMobile ? (
              <motion.div
                variants={boxVariantsPop}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0 }}
              >
                <div className="features1_component-copy text-left m-t-5">
                  <div className="features-item-1">
                    <div className="layout11_item">
                      <div className="layout11_icon-wrapper">
                        <img
                          src="/Images/SVG/Clients-o.svg"
                          loading="lazy"
                          alt=""
                        />
                      </div>
                      <div className="layout11_content-wrapper">
                        <div className="margin-bottom margin-small">
                          <h3 className="heading-small">
                            Embrace Efficiency with E-Cloud
                          </h3>
                        </div>
                        <p className="paragraph-11">
                          E-Cloud simplifies your document management and
                          enhances overall efficiency by ensuring that all
                          necessary files are well-organized and easily
                          accessible. Embrace the future of maritime document
                          management with E-Cloud and enjoy a more streamlined,
                          effective, and organized approach to filing.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="features-item-2">
                    <div className="layout11_item">
                      <div className="layout11_icon-wrapper">
                        <img
                          src="/Images/SVG/Stayaheadofremediationcosts-o.svg"
                          loading="lazy"
                          alt=""
                        />
                      </div>
                      <div className="layout11_content-wrapper">
                        <div className="margin-bottom margin-small">
                          <h3 className="heading-small">
                            End-to-End Encryption and Security
                          </h3>
                        </div>
                        <p className="paragraph-11">
                          E-Cloud is built with end-to-end encryption to keep
                          your data secure. Our advanced security protocols
                          ensure that your documents are protected from
                          unauthorized access, maintaining the confidentiality
                          and integrity of your sensitive information.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="features-item-3">
                    <div className="layout11_item">
                      <div className="layout11_icon-wrapper">
                        <img
                          src="/Images/SVG/Key trends.svg"
                          loading="lazy"
                          alt=""
                        />
                      </div>
                      <div className="layout11_content-wrapper">
                        <div className="margin-bottom margin-small">
                          <h3 className="heading-small">
                            Streamlined Access and Review
                          </h3>
                        </div>
                        <p className="paragraph-11">
                          Gone are the days of sifting through countless emails
                          and files. With E-Cloud, all your critical documents
                          are just a few clicks away, accessible from anywhere
                          at any time. This ensures that you can review and
                          retrieve ship reports swiftly and efficiently,
                          enhancing productivity and operational oversight.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="features-item-4">
                    <div className="layout11_item">
                      <div className="layout11_icon-wrapper">
                        <img
                          src="/Images/SVG/customerprocess-o.svg"
                          loading="lazy"
                          alt=""
                        />
                      </div>
                      <div className="layout11_content-wrapper">
                        <div className="margin-bottom margin-small">
                          <h3 className="heading-small">
                            Centralized Data Repository
                          </h3>
                        </div>
                        <p className="paragraph-11">
                          E-Cloud serves as a robust data repository,
                          continuously updated by vessels and readily accessible
                          by the shore office. This real-time synchronization
                          minimizes the need for extensive email communication
                          and ensures that ship reports are maintained at a
                          single, secure location.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>
            ) : (
              <div>
                <div className="features1_component-copy text-left m-t-5">
                  <div className="features-item-1">
                    <div className="layout11_item">
                      <div className="layout11_icon-wrapper">
                        <img
                          src="/Images/SVG/Clients-o.svg"
                          loading="lazy"
                          alt=""
                        />
                      </div>
                      <div className="layout11_content-wrapper">
                        <div className="margin-bottom margin-small">
                          <h3 className="heading-small">
                            Embrace Efficiency with E-Cloud
                          </h3>
                        </div>
                        <p className="paragraph-11">
                          E-Cloud simplifies your document management and
                          enhances overall efficiency by ensuring that all
                          necessary files are well-organized and easily
                          accessible. Embrace the future of maritime document
                          management with E-Cloud and enjoy a more streamlined,
                          effective, and organized approach to filing.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="features-item-2">
                    <div className="layout11_item">
                      <div className="layout11_icon-wrapper">
                        <img
                          src="/Images/SVG/Stayaheadofremediationcosts-o.svg"
                          loading="lazy"
                          alt=""
                        />
                      </div>
                      <div className="layout11_content-wrapper">
                        <div className="margin-bottom margin-small">
                          <h3 className="heading-small">
                            End-to-End Encryption and Security
                          </h3>
                        </div>
                        <p className="paragraph-11">
                          E-Cloud is built with end-to-end encryption to keep
                          your data secure. Our advanced security protocols
                          ensure that your documents are protected from
                          unauthorized access, maintaining the confidentiality
                          and integrity of your sensitive information.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="features-item-3">
                    <div className="layout11_item">
                      <div className="layout11_icon-wrapper">
                        <img
                          src="/Images/SVG/Key trends.svg"
                          loading="lazy"
                          alt=""
                        />
                      </div>
                      <div className="layout11_content-wrapper">
                        <div className="margin-bottom margin-small">
                          <h3 className="heading-small">
                            Streamlined Access and Review
                          </h3>
                        </div>
                        <p className="paragraph-11">
                          Gone are the days of sifting through countless emails
                          and files. With E-Cloud, all your critical documents
                          are just a few clicks away, accessible from anywhere
                          at any time. This ensures that you can review and
                          retrieve ship reports swiftly and efficiently,
                          enhancing productivity and operational oversight.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="features-item-4">
                    <div className="layout11_item">
                      <div className="layout11_icon-wrapper">
                        <img
                          src="/Images/SVG/customerprocess-o.svg"
                          loading="lazy"
                          alt=""
                        />
                      </div>
                      <div className="layout11_content-wrapper">
                        <div className="margin-bottom margin-small">
                          <h3 className="heading-small">
                            Centralized Data Repository
                          </h3>
                        </div>
                        <p className="paragraph-11">
                          E-Cloud serves as a robust data repository,
                          continuously updated by vessels and readily accessible
                          by the shore office. This real-time synchronization
                          minimizes the need for extensive email communication
                          and ensures that ship reports are maintained at a
                          single, secure location.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            </Col>
          </Row>
        </Container>
      </Row>
     <Container style={{ padding: "0" }} className=" m-t-70 text-left">
          <Row style={{ margin: "0", padding: "0" }}>
             <Col xs={12} sm={2}></Col>
            <Col xs={12} sm={8} className="text-center">
              <h2 className="font-bold text-center">Frequently Asked Questions</h2>
               <Accordion alwaysOpen className="text-start">
                        <Row className="CommonAccordion m-t-40">
                          <Accordion.Item eventKey="14" className=" mt-2 mb-2">
                            <Accordion.Header>
                             Q1. What is E-Cloud and why is it important?
                            </Accordion.Header>
                            <Accordion.Body>
                             <p>
                            E-Cloud is a maritime cloud-based platform designed to centralize and manage all vessel-related data and applications. It enables real-time access, streamlined communication, and improved operational efficiency across fleets.
                             </p>
                            </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="15" className=" mt-2 mb-2">
                            <Accordion.Header>
                            Q2. Can we control access to applications or data per role or user?
                            </Accordion.Header>
                            <Accordion.Body>
                              <p>
                               Yes, E-Cloud includes strong role-based access controls, ensuring that users only access the data and modules relevant to their roles and responsibilities.
                              </p>
                            </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="16" className=" mt-2 mb-2">
                            <Accordion.Header>
                            Q3. Is data version control or history tracking available?
                            </Accordion.Header>
                            <Accordion.Body>
                              <p>
                              Absolutely. E-Cloud supports version tracking and historical logs, helping teams monitor changes, maintain data integrity, and ensure auditability.
                              </p>
                            </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="17" className=" mt-2 mb-2">
                            <Accordion.Header>
                            Q4. Can we access E-Cloud services offline?
                            </Accordion.Header>
                            <Accordion.Body>
                             <p>
                           Offline access is in progress. Currently, E-Cloud provides secure access through its cloud infrastructure, ensuring data availability wherever there is an internet connection.
                             </p>
                            </Accordion.Body>
                          </Accordion.Item>
                         
                        </Row>
                      </Accordion>
            </Col>
          </Row>
       </Container>
    </>)
}